import { useState, useEffect } from 'react'
import useIntegrationCompat from './integrationCompatHook'

const useWindowSize = (elementSiblingHeight) => {
    const { siblingOffset, isMobile } = useIntegrationCompat()

    const [siblingHeight, setSiblingHeight] = useState(elementSiblingHeight)
    const [listMaxHeight, setListMaxHeight] = useState(window.innerHeight - siblingHeight - siblingOffset)

    const bottomSpacing = isMobile ? 0 : 40 // 40px for the chat screen

    useEffect(() => {
        setListMaxHeight(window.innerHeight - siblingHeight - siblingOffset - bottomSpacing)
        const listener = () => {
            setListMaxHeight(window.innerHeight - siblingHeight - siblingOffset - bottomSpacing)
        }

        window.addEventListener('resize', listener)

        return () => {
            window.removeEventListener('resize', listener)
        }
    }, [siblingHeight, siblingOffset])

    return { listMaxHeight, setSiblingHeight }
}

export default useWindowSize